import {
  Button,
  CloseButton,
  Flex,
  Heading,
  List,
  Spinner,
  Text,
  Tray,
  View,
} from "@instructure/ui";
import { t } from "i18next";
import { useState } from "react";
import Skeleton from "react-loading-skeleton";
import { Link } from "react-router-dom";
import EnrichedFileDrop from "../../LearningOutcomes/FileDrop/EnrichedFileDrop";

const UploadFileModal = ({
  enrichedContent,
  modalHeaderText,
  modalCopy,
  fileDropHeader,
  shouldOpen,
  handleSubmit,
  handleCancel,
  samplePath,
  fileExtensions,
  multiFileSupport,
  currentContents,
  refreshingFileList,
}) => {
  const [fileState, setFileState] = useState(null);
  const [uploading, setUploading] = useState(false);

  const handleSubmitFiles = async () => {
    setUploading(true);
    await handleSubmit(fileState);
    setUploading(false);
  };

  return (
    <Tray
      size="regular"
      label={t("assessment.uploadDialog")}
      open={shouldOpen}
      placement="end"
      onClose={() => setFileState(null)}
    >
      <View as="div" padding="small">
        <Flex margin="0 0 small 0">
          <Flex.Item shouldGrow shouldShrink>
            <Heading level="h2" as="h1" border="bottom">
              {modalHeaderText}
            </Heading>
          </Flex.Item>
          <Flex.Item>
            <CloseButton
              placement="end"
              offset="small"
              screenReaderLabel={t("global.close")}
              onClick={handleCancel}
            />
          </Flex.Item>
        </Flex>
        <View as="div">
          <EnrichedFileDrop
            fileState={fileState}
            setFileState={setFileState}
            enriched_content={enrichedContent}
            fileDropHeading={fileDropHeader}
            fileExtension={fileExtensions}
            multiFileSupport={multiFileSupport}
          />

          <div style={{ marginTop: 10 }}>
            {modalCopy}
            {samplePath && (
              <Text as="div">
                <Link to={samplePath} target="_blank">
                  {t("global.downloadExampleFile")}
                </Link>
              </Text>
            )}
          </div>
          <Flex justifyItems="end">
            <Flex.Item>
              <Button margin="0 small 0 0" onClick={handleCancel}>
                {t("global.cancel")}
              </Button>
              <Button
                onClick={handleSubmitFiles}
                color="primary"
                disabled={!fileState || uploading}
              >
                {uploading ? (
                  <Spinner
                    renderTitle={t("global.pleaseWait")}
                    size="x-small"
                  />
                ) : (
                  t("global.submit")
                )}
              </Button>
            </Flex.Item>
          </Flex>
          {refreshingFileList && (
            <Skeleton style={{ height: 64, borderRadius: 5, marginTop: 10 }} />
          )}
          {!refreshingFileList && currentContents?.length > 0 && (
            <Text>
              <Text weight="bold">{t("assessment.currentEvidenceList")}:</Text>
              <List>
                {currentContents.map((file, idx) => (
                  <List.Item key={idx} size="small">
                    {file.file_name}
                  </List.Item>
                ))}
              </List>
            </Text>
          )}
        </View>
      </View>
    </Tray>
  );
};

export default UploadFileModal;
